import script from "./SubscribeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeItem.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeItem.vue?vue&type=style&index=0&id=dc6a8314&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc6a8314"]])

export default __exports__